import * as React from 'react';
import {
  Paper,
  withStyles,
  WithStyles,
  StyleRulesCallback
} from '@material-ui/core';
import Control from 'react-leaflet-control';

import { HistogramChart, BinLegend } from './';
import { GeotiffRender } from '../utils/renderGeotiffRaster';
import { Histogram } from 'geotiff-utils';

interface Props {
  open: boolean;
  totalArea?: number | null;
  render: GeotiffRender | null;
  dense?: boolean;
  fractionDigits?: number;
  suffix?: string;
  onClick?: () => void;
}

const styles: StyleRulesCallback = theme => ({
  wrapper: {
    cursor: 'zoom-in'
  },
  chart: {
    cursor: 'zoom-in'
  }
});

class RasterMapReference extends React.PureComponent<Props & WithStyles> {
  renderContent(histogram: Histogram, bins: NdviRasterBins, totalArea: number) {
    const { classes, onClick, fractionDigits, suffix } = this.props;

    return (
      <Paper elevation={1} className={classes.wrapper} onClick={onClick}>
        <HistogramChart
          height={150}
          width={200}
          histogram={histogram}
          bins={bins}
        />
        <BinLegend
          dense={true}
          histogram={histogram}
          bins={bins}
          totalArea={totalArea}
          fractionDigits={fractionDigits}
          suffix={suffix}
        />
      </Paper>
    );
  }

  render() {
    const { open, render, totalArea } = this.props;

    return (
      <Control position="topright">
        <>
          {open &&
            render &&
            render.histogram &&
            render.bins &&
            totalArea &&
            this.renderContent(render.histogram, render.bins, totalArea)}
        </>
      </Control>
    );
  }
}

export default withStyles(styles)(RasterMapReference);



// WEBPACK FOOTER //
// ./src/components/RasterMapReference.tsx